import Collar from "../../assets/icons/collar/collar.svg"
import Sleeve from "../../assets/icons/sleeve/sleeve.svg"
import Cutaway from "../../assets/icons/collar/cutaway.svg"
import Kent from "../../assets/icons/collar/kent.svg"
import ButtonDown from "../../assets/icons/collar/button_down.svg"
import Wing from "../../assets/icons/collar/wing.svg"
import Rounded from "../../assets/icons/collar/rounded.svg"
import ShortClassic from "../../assets/icons/collar/short_classic.svg"
import Pinned from "../../assets/icons/collar/pinned.svg"
import NewKent from "../../assets/icons/collar/new_kent.svg"
import StandUp from "../../assets/icons/collar/stand_up.svg"
import Long from "../../assets/icons/sleeve/long.svg"
import Short from "../../assets/icons/sleeve/short.svg"
import Cuffs from "../../assets/icons/cuffs/cuffs.svg"
import DoubleSquareFrenchCuff from "../../assets/icons/cuffs/double_square_french_cuff.svg"
import OneButtonCut from "../../assets/icons/cuffs/one_button_cut.svg"
import RoundedFrenchCuff from "../../assets/icons/cuffs/rounded_french_cuff.svg"
import SingleCuffsTwoButton from "../../assets/icons/cuffs/single_cuffs_two_button.svg"
import SquareFrenchCuff from "../../assets/icons/cuffs/square_french_cuff.svg"
import Fit from "../../assets/icons/fit/fit.svg"
import SlimFit from "../../assets/icons/fit/slim_fit.svg"
import Regular from "../../assets/icons/fit/regular.svg"
import Bottom from "../../assets/icons/bottom/bottom.svg"
import Square from "../../assets/icons/bottom/square.svg"
import Tail from "../../assets/icons/bottom/tail.svg"
import Tucked from "../../assets/icons/bottom/tucked.svg"
import Untucked from "../../assets/icons/bottom/untucked.svg"
import Chestpocket from "../../assets/icons/chestpocket/chestpocket.svg"
import ChestpocketStandard from "../../assets/icons/chestpocket/chestpocket_standard.svg"
import DoubleStandard from "../../assets/icons/chestpocket/double_standard.svg"
import NoPocket from "../../assets/icons/chestpocket/no_pocket.svg"
import DoubleWithFlap from "../../assets/icons/chestpocket/double_with_flap.svg"
import WithFlap from "../../assets/icons/chestpocket/with_flap.svg"
import Placket from "../../assets/icons/placket/placket.svg"
import PlacketStandard from "../../assets/icons/placket/placket_standard.svg"
import PlacketFrench from "../../assets/icons/placket/placket_french.svg"
import PlacketHidden from "../../assets/icons/placket/placket_hidden.svg"
import Pleats from "../../assets/icons/pleats/pleats.svg"
import PleatsStandard from "../../assets/icons/pleats/pleats_standard.svg"
import PleatsHidden from "../../assets/icons/pleats/pleats_hidden.svg"
import PleatsFrench from "../../assets/icons/pleats/pleats_french.svg"
import ButtonIcon from "../../assets/icons/button/button.svg"

const style_json = [
    {
        name: "Collar",
        image: Collar,
        folded:[
            {
                name: "Cutaway",
                image: Cutaway,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Cutaway Placket French Folded"
            },
            {
                name: "Kent",
                image: Kent,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Kent"
            },
            {
                name: "Button Down",
                image: ButtonDown,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Botton Down Placket French Folded",
            },
            {
                name: "Wing",
                image: Wing,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Wing Placket French Folded"
            },
            {
                name: "Rounded",
                image: Rounded,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Rounded Placket French Folded"
            },
            // {
            //     name: "Short Classic",
            //     image: ShortClassic,
            //     isHover: false,
            //     file: "",
            //     id: null,
            //     code: "Collar Short Classic"
            // },
            {
                name: "Long",
                image: Long,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Long Placket French Folded"
            },
            {
                name: "Pinned",
                image: Pinned,
                isHover: false,
                file: "",
                id: null,
                code:"Collar Pinned Placket French Folded"
            },
            {
                name: "New Kent",
                image: NewKent,
                isHover: false,
                file: "",
                id: null,
                code: "Collar New Kent Placket French Folded"
            },
            {
                name: "Stand Up",
                image: StandUp,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Stand Up Placket French Folded"
            },
        ],
        // back:[
        //     {
        //         name: "Cutaway",
        //         image: Cutaway,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Cutaway Placket French Back"
        //     },
        //     {
        //         name: "Kent",
        //         image: Kent,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Kent Placket Hidden Back"
        //     },
        //     {
        //         name: "Button Down",
        //         image: ButtonDown,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Botton Down Placket French Back",
        //     },
        //     {
        //         name: "Wing",
        //         image: Wing,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Wing Placket French Back"
        //     },
        //     {
        //         name: "Rounded",
        //         image: Rounded,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Rounded Placket French Back"
        //     },
        //     {
        //         name: "Short Classic",
        //         image: ShortClassic,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Short Classic"
        //     },
        //     {
        //         name: "Long",
        //         image: Long,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Long Placket French Back"
        //     },
        //     {
        //         name: "Pinned",
        //         image: Pinned,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code:"Collar Pinned Placket French Back"
        //     },
        //     {
        //         name: "New Kent",
        //         image: NewKent,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar New Kent Placket French Back"
        //     },
        //     {
        //         name: "Stand Up",
        //         image: StandUp,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Stand Up Placket French Back"
        //     },
        // ],
        front:[
            {
                name: "Cutaway",
                image: Cutaway,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Cutaway Placket Hidden Front"
            },
            {
                name: "Kent",
                image: Kent,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Kent Placket Hidden Front"
            },
            {
                name: "Button Down",
                image: ButtonDown,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Button Down Placket Standard Front",
            },
            {
                name: "Wing",
                image: Wing,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Wing Placket Hidden Front"
            },
            {
                name: "Rounded",
                image: Rounded,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Rounded Placket Hidden Front"
            },
            // {
            //     name: "Short Classic",
            //     image: ShortClassic,
            //     isHover: false,
            //     file: "",
            //     id: null,
            //     code: "Collar Short Classic"
            // },
            {
                name: "Long",
                image: Long,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Long Placket Hidden Front"
            },
            {
                name: "Pinned",
                image: Pinned,
                isHover: false,
                file: "",
                id: null,
                code:"Collar Pinned Placket Hidden Front"
            },
            {
                name: "New Kent",
                image: NewKent,
                isHover: false,
                file: "",
                id: null,
                code: "Collar New Kent Placket Hidden Front"
            },
            {
                name: "Stand Up",
                image: StandUp,
                isHover: false,
                file: "",
                id: null,
                code: "Collar Stand Up Placket Hidden Front"
            },
        ],
        
        // data: [
        //     {
        //         name: "Cutaway",
        //         image: Cutaway,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Cutaway Placket Hidden Folded"
        //     },
        //     {
        //         name: "Kent",
        //         image: Kent,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Kent"
        //     },
        //     {
        //         name: "Button Down",
        //         image: ButtonDown,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Button Down Placket Hidden Folded"
        //     },
        //     {
        //         name: "Wing",
        //         image: Wing,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Wing Placket French Folded"
        //     },
        //     {
        //         name: "Rounded",
        //         image: Rounded,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Rounded Placket French Folded"
        //     },
        //     {
        //         name: "Short Classic",
        //         image: ShortClassic,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Short Classic"
        //     },
        //     {
        //         name: "Long",
        //         image: Long,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Long"
        //     },
        //     {
        //         name: "Pinned",
        //         image: Pinned,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Pinned"
        //     },
        //     {
        //         name: "New Kent",
        //         image: NewKent,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar New Kent"
        //     },
        //     {
        //         name: "Stand Up",
        //         image: StandUp,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Collar Stand Up"
        //     },
        // ]
    },
    {
        name: "Cuffs",
        image: Cuffs,
        front:[
            {
                name: "Single Two Button",
                image: SingleCuffsTwoButton,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single Two Button"
            },
            {
                name: "One Button",
                image: OneButtonCut,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs One Button"
            },
            {
                name: "Square French",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Square French"
            },
            {
                name: "Double Square French",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Square French"
            },
            {
                name: "Rounded French",
                image: RoundedFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Rounded French"
            },
        ],
        back:[
            {
                name: "Single Two Button",
                image: SingleCuffsTwoButton,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single One Button Back"
            },
            {
                name: "Single Two Button",
                image: OneButtonCut,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single Two Button Back"
            },
            {
                name: "Single One Button",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single One Button Back"
            },
            {
                name: "Two Button Cut",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Two Button Cut Back"

            },
            {
                name: "One Button Cut",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs One Button Cut Back"
            },
            {
                name: "Rounded One Button",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Rounded One Button Back"
            },
            {
                name: "Rounded Two Button",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Rounded Two Button Back"
            },
            {
                name: "Square French",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Square French Back"
            },
            {
                name: "Rounded French",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Rounded French Back"
            },
            {
                name: "Double Square French",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Square French Back"
            },
            {
                name:"Double Rounded French",
                image: RoundedFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Rounded French Back"
            },
            {
                name: "Rounded French",
                image: RoundedFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Rounded French Back"
            },
        ],
        folded:[
            {
                name: "Single Two Button",
                image: SingleCuffsTwoButton,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single One Button Folded"
            },
            {
                name: "Single Two Button",
                image: OneButtonCut,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single Two Button Folded"
            },
            {
                name: "Single One Button",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Single One Button Folded"
            },
            {
                name: "Two Button Cut",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Two Button Cut Folded"

            },
            {
                name: "One Button Cut",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs One Button Cut Folded"
            },
            {
                name: "Rounded One Button",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Rounded One Button Folded"
            },
            {
                name: "Square French",
                image: SquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Square French Folded"
            },
            {
                name: "Rounded French",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Rounded French Folded"
            },
            {
                name: "Double Square French",
                image: DoubleSquareFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Square French Folded"
            },
            {
                name:"Double Rounded French",
                image: RoundedFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Rounded French Folded"
            },
            {
                name: "Rounded French",
                image: RoundedFrenchCuff,
                isHover: false,
                file: "",
                id: null,
                code: "Cuffs Double Rounded French Folded"
            },
        ],
        
        // data: [
        //     {
        //         name: "Single Two Button",
        //         image: SingleCuffsTwoButton,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Cuffs Single Two Button"
        //     },
        //     {
        //         name: "One Button",
        //         image: OneButtonCut,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Cuffs One Button"
        //     },
        //     {
        //         name: "Square French",
        //         image: SquareFrenchCuff,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Cuffs Square French"
        //     },
        //     {
        //         name: "Double Square French",
        //         image: DoubleSquareFrenchCuff,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Cuffs Double Square French"
        //     },
        //     {
        //         name: "Rounded French",
        //         image: RoundedFrenchCuff,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Cuffs Rounded French"
        //     },
        // ],
    },
    {
        name: "Sleeve",
        image: Sleeve,
        front: [
            {
                name: "Long",
                image: Long,
                isHover: false,
                file: "",
                id: null,
                code: "Sleeve Long Front"
            },
            {
                name: "Short",
                image: Short,
                isHover: false,
                file: "",
                id: null,
                code: "Sleeve Short Front"
            },
        ],
        // data: [
        //     {
        //         name: "Long",
        //         image: Long,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Sleeve Long"
        //     },
        //     {
        //         name: "Short",
        //         image: Short,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Sleeve Short"
        //     },
        // ],
    },
    // {
    //     name: "Fit",
    //     image: Fit,
    //     data: [
    //         {
    //             name: "Slim",
    //             image: SlimFit,
    //             isHover: false,
    //             file: "",
    //             id: null,
    //             code: "Fit Slim"
    //         },
    //         {
    //             name: "Regular",
    //             image: Regular,
    //             isHover: false,
    //             file: "",
    //             id: null,
    //             code: "Fit Regular"
    //         },
    //     ],
    // },
    {
        name: "Chestpocket",
        image: Chestpocket,
        front: [
            // {
            //     name: "No Pocket",
            //     image: NoPocket,
            //     isHover: false,
            //     file: "",
            //     id: null,
            //     code: "Chestpocket No Pocket"
            // },
            {
                name: "With Flap",
                image: WithFlap,
                isHover: false,
                file: "",
                id: null,
                code: "Chestpocket With Flap Front"
            },
            {
                name: "Standard",
                image: ChestpocketStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Chestpocket Standard Front"
            },
            {
                name: "Double With Flap",
                image: DoubleWithFlap,
                isHover: false,
                file: "",
                id: null,
                code: "Chestpocket Double With Flap Front"
            },
            {
                name: "Double Standard",
                image: DoubleStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Chestpocket Double Standard Front"
            },
        ],
        // data: [
        //     // {
        //     //     name: "No Pocket",
        //     //     image: NoPocket,
        //     //     isHover: false,
        //     //     file: "",
        //     //     id: null,
        //     //     code: "Chestpocket No Pocket"
        //     // },
        //     {
        //         name: "With Flap",
        //         image: WithFlap,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Chestpocket With Flap"
        //     },
        //     {
        //         name: "Standard",
        //         image: ChestpocketStandard,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Chestpocket Standard"
        //     },
        //     {
        //         name: "Double With Flap",
        //         image: DoubleWithFlap,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Chestpocket Double With Flap"
        //     },
        //     {
        //         name: "Double Standard",
        //         image: DoubleStandard,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Chestpocket Double Standard"
        //     },
        // ],
    },
    {
        name: "Placket",
        image: Placket,
        folded: [
            {
                name: "Standard",
                image: PlacketStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Placket Standard Body Folded"
            },
            {
                name: "Hidden",
                image: PlacketHidden,
                isHover: false,
                file: "",
                id: null,
                code: "Placket Hidden Body Folded"
            },
            {
                name: "French",
                image: PlacketFrench,
                isHover: false,
                file: "",
                id: null,
                code: "Placket French Body Folded"
            },
        ],
    },
    {
        name: "Pleats",
        image: Pleats,
        back: [
            {
                name: "Box Tucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Box Tucked"
            },
            {
                name: "Plain Tucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Plain Tucked"
            },
            {
                name: "Side Fold Tucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code:"Pleats Side Fold Tucked"
            },
            {
                name: "Box Untucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Box Untucked"
            },
            {
                name: "Side Untucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Side Untucked"
            },
            {
                name: "Slim Fit Square Untucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Slim Fit Square Untucked"
            },
            {
                name: "Slim Fit Tail Untucked",
                image: PleatsStandard,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Slim Fit Tail Untucked"
            },
            {
                name: "Hidden",
                image: PleatsHidden,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats Hidden"
            },
            {
                name: "French",
                image: PleatsFrench,
                isHover: false,
                file: "",
                id: null,
                code: "Pleats French"
            },
        ],
        // data: [
        //     {
        //         name: "Standard",
        //         image: PleatsStandard,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Pleats Standard"
        //     },
        //     {
        //         name: "Hidden",
        //         image: PleatsHidden,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Pleats Hidden"
        //     },
        //     {
        //         name: "French",
        //         image: PleatsFrench,
        //         isHover: false,
        //         file: "",
        //         id: null,
        //         code: "Pleats French"
        //     },
        // ],
    },
    {
        name: "Button",
        image: ButtonIcon,
        front:[
            { name: "Default", isHover: false, file: "", id: null, code: "FRONT_Button__Accent-Default" },
            { name: "Regular", isHover: false, file: "", id: null, code: "FRONT_Button__Accent-Regular" },
            { name: "Pocket A", isHover: false, file: "", id: null, code: "FRONT_Button__Accent-Pocket A" },
            { name: "Pocket B", isHover: false, file: "", id: null, code: "FRONT_Button__Accent-Pocket B" },
            { name: "Button Down Collar A", isHover: false, file: "", id: null, code: "FRONT_Button__Accent-Button Down Collar A" },
            { name: "Button Down Collar B", isHover: false, file: "", id: null, code: "FRONT_Button__Accent-Button Down Collar B" }
        ],
        back:[
            { name: "Default", isHover: false, file: "", id: null, code: "BACK_Button__Accent-Default" },
            { name: "Regular", isHover: false, file: "", id: null, code: "BACK_Button__Accent-Regular" },
            { name: "Pocket A", isHover: false, file: "", id: null, code: "BACK_Button__Accent-Pocket A" },
            { name: "Pocket B", isHover: false, file: "", id: null, code: "BACK_Button__Accent-Pocket B" },
            { name: "Button Down Collar A", isHover: false, file: "", id: null, code: "BACK_Button__Accent-Button Down Collar A" },
            { name: "Button Down Collar B", isHover: false, file: "", id: null, code: "BACK_Button__Accent-Button Down Collar B" }
        ],
        folded:[
            { name: "Default", isHover: false, file: "", id: null, code: "FOLDED_Button__Accent-Default" },
            { name: "Regular", isHover: false, file: "", id: null, code: "FOLDED_Button__Accent-Regular" },
            { name: "Pocket A", isHover: false, file: "", id: null, code: "FOLDED_Button__Accent-Pocket A" },
            { name: "Pocket B", isHover: false, file: "", id: null, code: "FOLDED_Button__Accent-Pocket B" },
            { name: "Button Down Collar A", isHover: false, file: "", id: null, code: "FOLDED_Button__Accent-Button Down Collar A" },
            { name: "Button Down Collar B", isHover: false, file: "", id: null, code: "FOLDED_Button__Accent-Button Down Collar B" }
        ]
    }
]

export default style_json